// extracted by mini-css-extract-plugin
export default {"Title":"rbzTBH8MjZLqdfAHnYB5","h2":"UNx4iOxwU2hedTp9nE88"};